// extracted by mini-css-extract-plugin
module.exports = {"cartCard":"styles_cartCard__3gfMd","btnRemove":"styles_btnRemove__3LGOj"};